module.exports = __webpack_public_path__ + "static/img/poster-bac3.e5081908.png";